export default "__VITE_ASSET__dbda6c4d__"